var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.65,
    height: 113.65,
    viewBox: "0 0 113.65 113.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.82,
    cy: 56.82,
    r: 56.82,
    fill: "#4196c8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.17,
    y: 48.32,
    width: 53.3,
    height: 5.3,
    rx: 2.65,
    ry: 2.65,
    fill: "none",
    stroke: "#dedede",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.09,53.62h47.47v2.06c0,11.3-9.17,20.47-20.47,20.47h-6.53c-11.3,0-20.47-9.17-20.47-20.47v-2.06h0Z",
    fill: "none",
    stroke: "#dedede",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.32,42.82h4c1.1,0,2,.9,2,2v1c0,1.1-.9,2-2,2h-4v-5h0Z",
    transform: "translate(21 111.65) rotate(-90)",
    fill: "none",
    stroke: "#dedede",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.25,42.75h4.15c1.1,0,2,.9,2,2v1c0,1.1-.9,2-2,2h-4.15v-5h0Z",
    transform: "translate(2.07 92.58) rotate(-90)",
    fill: "none",
    stroke: "#dedede",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.82,48.32v-13c0-1.66,1.34-3,3-3h0c1.66,0,3,1.34,3,3v2",
    fill: "none",
    stroke: "#dedede",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "63.82 75.32 63.82 81.32 49.82 81.32 49.82 75.32",
    fill: "none",
    stroke: "#dedede",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepair);
export default __webpack_public_path__ + "static/media/repair.8a3913fac4a74ec71f706ea64fa15fb0.svg";
export { ForwardRef as ReactComponent };